/**
 * view-error-boundary.tsx — catches lazy-chunk load failures (e.g. offline PWA
 * navigating to a never-cached view) so a failed dynamic import degrades to a
 * retry card instead of unmounting the whole app tree.
 */
import { Component } from "react";
import type { ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; retryKey: number };

export class ViewErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, retryKey: 0 };

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  handleRetry = () => {
    // Bump the key to force a remount, which re-attempts the dynamic import.
    this.setState((s) => ({ hasError: false, retryKey: s.retryKey + 1 }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="grid place-items-center rounded-3xl bg-white p-10 text-center">
          <p className="mb-3 text-[14px] font-semibold text-ink-700">
            Không tải được trang — có thể bạn đang ngoại tuyến.
          </p>
          <button
            onClick={this.handleRetry}
            className="gbrand rounded-2xl px-4 py-2.5 text-[13px] font-bold text-white"
          >
            Thử lại
          </button>
        </div>
      );
    }
    return <div key={this.state.retryKey}>{this.props.children}</div>;
  }
}
